//
//
//
//

export default {
  components: {},
  props: {
    index: {
      default: '',
      type: String,
    },
    item: {
      default: () => {},
      type: Object,
    },
  },
}
